export default function notPreRelease({
    isPreRelease,
}: {
    isPreRelease: boolean;
}): boolean {
    return !isPreRelease;
}
